import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import Swal from 'sweetalert2';
import { useLang } from './i18n/context';
import BrandMark from './components/BrandMark';
import { authApi } from './services/authApi';

function Register() {
  const navigate = useNavigate();
  const { t } = useLang();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const validateEmail = (value) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);

  const handleEmailBlur = () => {
    if (email && !validateEmail(email)) setEmailError(t('register.validEmail'));
    else setEmailError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password || !confirm) {
      Swal.fire({ title: t('register.fillAll'), icon: 'warning', confirmButtonText: t('register.confirm') });
      return;
    }
    if (!validateEmail(email)) {
      Swal.fire({ title: t('register.invalidEmail'), icon: 'warning', confirmButtonText: t('register.confirm') });
      return;
    }
    if (password.length < 8) {
      Swal.fire({ title: t('register.passwordTooShort'), icon: 'warning', confirmButtonText: t('register.confirm') });
      return;
    }
    if (password !== confirm) {
      Swal.fire({ title: t('register.passwordMismatch'), icon: 'warning', confirmButtonText: t('register.confirm') });
      return;
    }

    try {
      setSubmitting(true);
      await authApi.register({ email, password, inviteCode });

      Swal.fire({
        icon: 'success', title: t('register.success'),
        html: t('register.reviewMsg'),
        background: '#1e222d', color: '#d1d4dc',
        confirmButtonColor: '#bfa14a', confirmButtonText: t('register.goToLogin'),
      }).then(() => navigate('/login'));
    } catch (err) {
      console.error('注册失败：', err);
      Swal.fire({
        icon: 'error', title: t('register.failed'),
        text: err?.message || t('register.retryLater'),
        background: '#1e222d', color: '#d1d4dc',
        confirmButtonColor: '#ef5350', confirmButtonText: t('register.confirm'),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-form">
      <div className="auth-logo">
        <BrandMark className="auth-logo-mark" />
        GHOST
      </div>

      <h1 className="auth-title">{t('register.title')}</h1>
      <p className="auth-subtitle">Web3 Community</p>

      <form className="auth-card" onSubmit={handleSubmit}>
        <input type="text" placeholder={t('register.emailPlaceholder')} value={email} onChange={e => setEmail(e.target.value)} onBlur={handleEmailBlur} className={emailError ? 'input-error' : ''} />
        {emailError && <div className="input-error-text">{emailError}</div>}
        <input type="password" placeholder={t('register.passwordPlaceholder')} value={password} onChange={e => setPassword(e.target.value)} />
        <input type="password" placeholder={t('register.confirmPasswordPlaceholder')} value={confirm} onChange={e => setConfirm(e.target.value)} />
        <div className="auth-divider" />
        <input type="text" placeholder={t('register.inviteCodePlaceholder')} value={inviteCode} onChange={e => setInviteCode(e.target.value)} />
        <button type="submit" className="auth-submit" disabled={submitting}>
          {submitting ? t('register.submitting') : t('register.submit')}
        </button>
      </form>

      <div className="auth-footer">
        <button className="auth-link" onClick={() => navigate('/login')}>{t('register.backToLogin')}</button>
      </div>
    </div>
  );
}

export default Register;
